import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'child-cell',
  template: `
    <div class="flex align-items-center list-user-action">
        <a class="" href="javascript:void(0)" title="Edit"
        (click)="invokeParentEditMethod()" >
            <i class="bx bx-edit text-success me-1 font-size-16"></i>
        </a>
        <a class="" href="javascript:void(0)" title="Permissions"
        (click)="invokeParentShieldMethod()" >
            <i class="bx bx-shield-quarter text-warning me-1 font-size-16"></i>
        </a>
        <a class="" href="javascript:void(0)" title="Delete"
        (click)="invokeParentDeleteMethod()">
            <i class="bx bx-trash text-danger me-1 font-size-16"></i>
        </a>
    </div>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class EditShieldDeleteActionsRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // console.log('params', this.params);
  }

  public invokeParentEditMethod() {
    // this.params.context.componentParent.editService(
    //   `Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef?.headerName}`
    // );
    this.params.context.componentParent.editAction(this.params.node.data);
  }

  public invokeParentShieldMethod() {
    this.params.context.componentParent.shieldAction(this.params.node.data);
  }

  public invokeParentDeleteMethod() {
    this.params.context.componentParent.deleteAction(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}
